import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=6878b3a2&scoped=true"
import script from "./Announcements.vue?vue&type=script&lang=js"
export * from "./Announcements.vue?vue&type=script&lang=js"
import style0 from "./Announcements.vue?vue&type=style&index=0&id=6878b3a2&prod&lang=scss&scoped=true"
import style1 from "./Announcements.vue?vue&type=style&index=1&id=6878b3a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6878b3a2",
  null
  
)

export default component.exports